import React from 'react';
import PlanBoxItem from './PlanBoxItem';

const PlanBox = ({ data, btnFooterBg, btnFooterText }) =>
  <div>
    <div className="module-plans-outer">
      {data.map((item, index) => <PlanBoxItem key={index} {...item} />)}
    </div>
  </div>;

export default PlanBox;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/planBox/PlanBox.js